import(/* webpackMode: "eager", webpackExports: ["DrupalPage"] */ "/vercel/path0/src/app/DrupalPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppNodeContextProvider"] */ "/vercel/path0/src/AppContext.tsx");
